// extracted by mini-css-extract-plugin
export var bannerDetails = "homeHeader-module--bannerDetails--e5b68";
export var bannerImage = "homeHeader-module--bannerImage--e7106";
export var homeBanner = "homeHeader-module--homeBanner--52732";
export var subtext = "homeHeader-module--subtext--5e230";
export var tagline = "homeHeader-module--tagline--aeb84";
export var title = "homeHeader-module--title--8175a";